import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import * as enTranslations from './translations/en.json'
import * as nlTranslations from './translations/nl.json'

i18n.use(initReactI18next).init({
  lng: 'nl',
  resources: {
    en: {
      translations: { ...enTranslations },
    },
    nl: {
      translations: { ...nlTranslations },
    },
  },
  defaultNS: 'translations',
  fallbackLng: 'nl',
})

export default i18n
